import c from "../common";

export default {
  // Dashboard
  Title: c.voucher.en.uppercase + " & " + c.discount.en.uppercase,
  ReDate: "Release Date:",
  EndDate: "Expiry Date:",
  Qty: "Quantity",
  Released: "Released",
  Distributed: "Distributed",
  EstampReserved: "Reserved for Estamp redemption",
  RewardReserved: "Reserved for Promotion Code",
  WelcomeReserved: "Reserved for Platform New Joiner Event",
  Redeemed: "Redeemed",
  Sale: "For sale",
  Minus: "-",
  Invited: "Participated vendors:",
  Data: "Data",
  InventoryControl: "Inventory Control",
  AvailQty: "Available Inventory",
  SaleReserved: "Reserved for Sale",
  SelectAll: "Select all",

  // Message
  Info1: "Distributed to consumers",
  Info2: "Please state the detail of the voucher in the description",
  Info3: "go to Estamp to edit",
  Info4: "go to Reward Event to edit",
  Info5: "Controlled by Platform, cannot edit",
  Warning1: "Please provide a cover photo",
  Warning2: "Please select a Type",
  Warning3: "Price cannot be zero",
  Warning4: "Original Price cannot be zero",
  Warning5: "Discounted Price cannot be zero",
  Warning6: "Discounted Price should be smaller than Original Price",
  Warning7: "Percentage cannot be zero",
  Warning8: "Quantity cannot be zero",
  Warning9: "Please provide a Name",
  Warning10: "Please provide a Expiry Date",
  Warning11_1: "Description length cannot exceed ",
  Warning11_2: " Words",
  Warning12: "Please provide at lease 1 Terms",
  Warning13: "Please choose an Event",
  Warning14: "Cannot be empty",
  Warning15_1: "Terms length cannot exceed ",
  Warning16: "Must choose at lease one redeem shop",
  Success1: "Request submitted, waiting for approval",
  Success2: "Edit Success",
  Refresh: "Please refresh the page",
  Error1: "Error Occur",

  // Status
  Approved: c.Approved.en,
  WaitApprove: c.WaitApprove.en,
  Expired: c.Expired.en,
  Rejected: c.Rejected.en,
  Cancelled: c.Cancelled.en,

  // Common
  Voucher: c.voucher.en.uppercase,
  Discount: c.discount.en.uppercase,
  TakeAway: c.takeaway.en.uppercase,
  NA: c.NA.en,
  Cancel: c.cancel.en,
  Next: c.next.en,
  Previous: c.previous.en,
  Description: "Description:",
  Terms: "Terms & Conditions",
  Complete: c.complete.en,
  To: "To",

  // Step 1
  Create: "Create new voucher",
  Photo: "Voucher photo",
  Ratio: "Aspect ratio",
  FileSize: "File size",
  Upload: "Upload",

  // Step 2
  Name: "Name",
  VouType: "Voucher Type",
  Value: "Value",
  Amount: "Quantity",
  Plan: "Type",
  Percentage: "Percentage",
  Other: "Other",
  OriPrice: "Original Price",
  Discounted: "Discounted Price",
  CustomInput: "Custom Input",
  Template: "Choose from template",
  AddTerms: "Add Terms & Conditions",

  // Step 3
  Event: "Event",
  AvaDate: "Voucher Available Date",
  CanRedeem: "Can Redeem",

  // Summary
  Summary: "Summary",
  DoubleConfirm: "Check before submit",
  Submit: "Submit",

  // Result
  ToEstamp: "Create Estamp plan",
  Skip: "Skip for now",

  edit: "edit",
  cancel: "cancel",
  confirm: "confirm",
  addTotalQty: "Add Total Qty",
  save: "save",
  addQty: "add qty",
  waitForApprove_alert_title: "Approval in progress, please cancel the request first if you need to edit information",
  addTicketQty: "add total qty",
  cancelRequest: "cancel request",
  reject_alert_title: "Request rejected",
  reason: "reason",
  approved_alert_title: "Request approved",
  draft_alert_title: "Draft",
  submitRequest: "Submit",

  custom_expiry_btn: "Custom Expiry Date",
};
